export enum ModelGroupEnum {
    LargeGlassFront = 17,
    SmallGlassFront = 18
}

export enum BusinessTypeEnum {
    DSD = 1,
    ARTMDistributor = 2,
    SecondaryVolume = 3,
    OneTimeSpecialEvent = 4,
    RecurringSpecialEvent = 5,
    EquipmentOnly = 6,
    FullService = 7
}

export enum AppSettingEnum {
    CustomerRequestEmailAddress = 1,
    EquipmentRequestEmailAddress = 2,
    SMTPUserName = 3,
    SMTPPassword = 4,
    FromEmailAddress = 5,
    SMTPServerName = 6,
    SMTPPort = 7,
    TestMode = 8,
    BccEmailAddress = 9,
    MaintainCustomerUnsuppressCCEmailAddresses = 10,
    CCDSDTeamForMaintainCustomerRequests = 11,
    EnableCustomerLookups = 12,
    EnableEquipmentLookups = 13,
    HideSalesAndDeliveryOnMaintainCustomer = 14,
    FspAllowCommissionRateSelection = 23,
    WillCustomerSellDrPepperDefaultVallue = 29,
    DSDPlanningFreezeActive = 33
}

export enum RequestTypeEnum {
    SoldToCustomer = 1,
    FullServiceCustomer = 2,
    Payer = 3,
    EquipmentOnlyCustomer = 4,
    Driver = 5,
    MaintainCustomer = 6,
    EquipmentInstall = 7,
    EquipmentRemove = 8,
    EquipmentSwap = 9,
    EquipmentMove = 10,
    EquipmentSurvey = 11,
    VisitPlanUpdate = 12,
    ZRPartnerUpdate = 13,
    EquipmentMaintenance = 14,
    FullServicePricing = 15,
    PaperworkOnlyMove = 16,
    SuppressCustomer = 17,
    UnsuppressCustomer = 18,
    Miscellaneous = 19,
    PartnerFunctions = 20,
    UpdatePricing = 21,
    AccountsReceivableUpdate = 22,
    PayerLinkages = 23,
    InvoiceStatementCopies = 24,
    CollectionsSetup = 25,
    MICRChanges = 26,
    BillingDiscrepancy = 27
}

export enum SalesOfficeType {
    ProductionPlant = 1,
    DropSite = 2,
    DistributionCenter = 3,
    Combo = 4,
    MakeReadyCenter = 5,
    CrossDock = 6,
    Other = 7
}

export enum AddressType {
    Customer = 1,
    Billing = 2,
    Equipment = 3
}

export enum DayType {
    Call = 1,
    Delivery = 2,
    CustomerNotAvailable = 3
}

export enum RequestCustomerTypeEnum {
    ZRPartnerUpdate = 1,
    AppliesTo = 2
}

export enum CustomerTypeEnum {
    DSD = 1,
    FullService = 2
}

export enum PayerTypeEnum {
    Payer = 1,
    FullServiceCommissions = 2
}

export enum EquipmentTypeEnum {
    Core = 1,
    SpecialOrder = 2
}

export enum Feature {
    MaintainEmployees = 1,
    MaintainFlavors = 2,
    MaintainKeyAccounts = 3,
    MaintainModels = 4,
    MaintainModelGroups = 5,
    MaintainSubtradeChannels = 6,
    MaintainTradeGroups = 7,
    MaintainTradeNames = 8,
    MaintainVendPackages = 9,
    MaintainVendSizes = 10,
    MaintainVendSizeFlavorXrefs = 11,
    MaintainEquipmentGraphics = 12,
    ViewLogMessages = 13,
    SubmitVisitPlanUpdates = 14,
    CompleteVisitPlanUpdates = 15,
    SubmitZRPartnerUpdates = 16,
    CompleteZRPartnerUpdates = 17,
    MaintainFamilyTypes = 18,
    MaintainUserMessages = 19,
    SubmitFullServicePricingUpdates = 20,
    ReviewFullServicePricingUpdates = 21,
    BatchExport = 45,
    MaintainPaymentTerms = 46,
    MaintainPrimaryGroupOverrides = 47,
    MaintainSalesOffices = 47,
    PerformRequestWorkflow = 53,
    ExecutiveReviewFullServicePricingUpdates = 54,
    ViewImportAudits = 55,
    MaintainActivityReasons = 56,
    MaintainEquipmentTemplateRules = 57,
    PerformMassUpdates = 71,
    SuperUser = 73,
    SubmitMICRChanges = 75,
    MaintainDSDFreeze = 76,
    MaintainContactValidations = 86,
    MaintainSalesOfficeRequestTypes = 89,
}

export enum Section {
    VendorInfo = 17,
    CoolerLineItems = 18,
    FountainLineItems = 19,
}

export enum ActionEnum {
    Created = 1,
    Updated = 2,
    Emailed = 3,
    Submitted = 4,
    Completed = 5,
    Rejected = 6,
    InProgress = 7,
    PendingEquipmentInstall = 8
}

export enum RequestStatusEnum {
    Open = 1,
    Emailed = 2,
    Submitted = 3,
    Completed = 4,
    Rejected = 5,
    InProgress = 6,
    PendingEquipmentInstall = 7
}

export enum ActivityReasonEnum {
    EquipmentMove_NewLocationInSameStore = 21
}

export enum EquipmentClassEnum {
    Cooler = 1,
    Fountain = 2,
    Vendor = 3,
    FountainBarGun = 4
}

export enum EquipmentActivityEnum {
    Install = 1,
    Remove = 2
}

export enum EmployeeActivationRequestStatusEnum {
    Open = 1,
    Complete = 2
}

export enum OrderMethodEnum {
    ECOM = 1,
    Call = 2,
    EDI = 3,
    Email = 4,
    Fax = 5,
    Inbound = 6,
    SalesRep = 7,
    None = 8
}

export enum FullServicePricingTypeEnum {
    TierOnGrid = 1,
    Contract = 3,
    OffGrid = 4
}

export enum CompletionNumberTypeEnum {
    None = 1,
    Single = 2,
    Multiple = 3
}

export enum CustomerOwnershipEnum {
    Corporate = 1,
    Franchisee = 2
}

export enum MassUpdateEntityEnum {
    PrimaryGroup = 1,
    PrimaryGroupOverride = 2,
    Employee = 3,
    SubtradeChannel = 4
}

export enum ApprovalType {
    ModelApproval = 1
}

export enum UpdateNeededEnum {
    Delete = 1,
    Update = 2,
    Insert = 3
}

export enum BillingDiscrepancyRequestTypeEnum {
    PricingDiscrepancyCorrection = 1,
    SalesTaxCorrection = 2,
    CreditMemoReinstate = 3,
    CRVCorrection = 4,
    MOV_MOQOffDayCorrection = 5
}

export enum ExportFileEnum {
    PartnerFunction = 6
}

export enum ValidationTypeEnum {
    EmailDomain = 1,
    EmailName = 2,
    PhoneNumber = 3
}
